import { RESET_CACHED_MAP_MARKERS } from '../constants/index'
export function resetCachedMapMarkers() {
  return {
    type: RESET_CACHED_MAP_MARKERS,
  }
}



// WEBPACK FOOTER //
// ./src/actions/resetCachedMapMarkers.js